import { ExpressionSpecification } from 'maplibre-gl'

export const defaultExpression: ExpressionSpecification = ['case', true, '#a9a9a9', '#a9a9a9']
